<template>
  <div class="subsidy-qualification-page">
    <!-- Tab 切换栏 -->
    <div class="tab-nav">
      <div
        class="tab-item"
        :class="{ active: activeTab === 'qualification' }"
        @click="activeTab = 'qualification'"
      >
        补贴资格
      </div>
      <div
        class="tab-item"
        :class="{ active: activeTab === 'application' }"
        @click="activeTab = 'application'"
      >
        补贴申报
      </div>
    </div>

    <!-- 页面容器 -->
    <div class="container">
      <!-- 补贴资格 Tab 内容 -->
      <div v-if="activeTab === 'qualification'">
        <!-- 资格标签 -->
        <div class="qualification-tag">
          <i class="el-icon-success"></i>
          <span>资格优秀 · 建议补贴</span>
        </div>

        <!-- 资格分析标题 -->
        <div class="analysis-title">
          <i class="el-icon-s-data"></i>
          <span>基于运营数据与财务统计的资格分析</span>
        </div>

        <!-- 核心数据卡片 -->
        <div class="data-cards">
          <div class="data-card">
            <div class="data-value">120</div>
            <div class="data-label">年营业额(万元)</div>
          </div>
          <div class="data-card">
            <div class="data-value">26.5%</div>
            <div class="data-label">资产负债率</div>
          </div>
          <div class="data-card benchmark-card">
            <div class="data-value">再生资源行业<br />基准</div>
            <div class="data-label">参考值:营收≥80万/负债≤50%</div>
          </div>
        </div>

        <!-- 综合资格指数 -->
        <div class="index-section">
          <div class="index-title">综合资格指数</div>
          <div class="progress-container">
            <el-progress
              :percentage="92"
              :stroke-width="24"
              color="#4cd964"
              text-inside
              class="index-progress"
            >
              <span class="progress-text">92 / 100</span>
            </el-progress>
          </div>
          <div class="index-desc">
            基于企业实际运营数据:年营业额120万元，资产负债率26.5%。营收规模超出再生资源行业基准线，经营能力较强。资产负债率处于健康水平，财务结构稳健。
          </div>
        </div>

        <!-- 审批决策依据 -->
        <div class="decision-section">
          <div class="decision-title">
            <i class="el-icon-bullseye"></i>
            <span>政府补贴审批决策依据</span>
          </div>
          <div class="decision-content">
            <i class="el-icon-check"></i>
            <span
              >综合评分92分：企业运营数据及财务数据表现优秀，符合再生资源行业补贴资格，建议优先审批。</span
            >
          </div>
        </div>

        <!-- 历史记录 -->
        <div class="history-section">
          <div class="history-header">
            <div class="history-title">
              <i class="el-icon-document-copy"></i>
              <span>申报资格历史记录</span>
            </div>
            <el-button type="text" class="refresh-btn">
              <i class="el-icon-refresh"></i> 刷新
            </el-button>
          </div>

          <!-- 历史记录表格 -->
          <el-table
            ref="recordsTable"
            :data="historyList"
            highlight-current-row
            style="width: 100%"
            :header-cell-style="{
              background: '#f8fafc',
              color: '#606266',
              fontWeight: '600',
            }"
            :cell-style="{ padding: '16px 0' }"
            empty-text="暂无上报记录"
            class="elegant-table"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="companyName"
              label="企业全称"
              width="100"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column
              prop="companyType"
              label="企业性质"
              width="120"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="creditCode"
              label="统一社会信用代码"
              width="170"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="annualTurnover"
              label="年营业额（万元）"
              width="140"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="assetLiabilityRatio"
              label="资产负债率（%）"
              width="140"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="businessScope"
              label="再生资源经营范围（主营）"
              width="220"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="environmentalCode"
              label="环保合规证明编号"
              width="220"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="auditStatus"
              label="审核状态"
              width="80"
              align="center"
            >
              <template slot-scope="scope">
                {{
                  scope.row.auditStatus === 0
                    ? '待审核'
                    : scope.row.auditStatus === 1
                      ? '通过'
                      : '驳回'
                }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <!-- 补贴申报 Tab 内容（占位） -->
      <div v-if="activeTab === 'application'" class="tab-placeholder">
        <div class="placeholder-content">
          <div class="form-container">
            <!-- 页面标题 -->
            <div class="price-report-wrapper">
              <div class="price-report-card">
                <!-- 顶部操作栏 -->
                <div class="operation-header">
                  <h2 class="title">
                    <i class="el-icon-notebook-2"></i>
                    补贴申报记录
                  </h2>
                </div>

                <!-- 数据表格区域 -->
                <div class="table-container">
                  <el-table
                    ref="recordsTable"
                    :data="reportRecords"
                    highlight-current-row
                    style="width: 100%"
                    :header-cell-style="{
                      background: '#f8fafc',
                      color: '#606266',
                      fontWeight: '600',
                    }"
                    :cell-style="{ padding: '16px 0' }"
                    empty-text="暂无上报记录"
                    class="elegant-table"
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="80"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="companyName"
                      label="企业全称"
                      width="150"
                      show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                      prop="creditCode"
                      label="统一社会信用代码"
                      width="180"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="subsidyType"
                      label="申报补贴类型"
                      width="170"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="applyAmount"
                      label="申报金额(万元)"
                      width="140"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="projectDesc"
                      label="项目/业绩简述"
                      width="300"
                      align="center"
                    ></el-table-column>
                    <el-table-column
                      prop="auditStatus"
                      label="审核状态"
                      width="80"
                      align="center"
                    >
                      <template slot-scope="scope">
                        {{
                          scope.row.auditStatus === 0
                            ? '待审核'
                            : scope.row.auditStatus === 1
                              ? '通过'
                              : '驳回'
                        }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      fixed="right"
                      label="操作"
                      align="center"
                      width="100"
                    >
                      <template slot-scope="scope">
                        <el-button
                          type="text"
                          size="small"
                          @click="handleClick(scope)"
                          class="detail-btn"
                        >
                          查看
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <el-dialog
              title="补贴申报"
              :visible.sync="showDialog"
              width="800px"
              :close-on-click-modal="false"
            >
              <div class="performance-upload-page">
                <!-- 绩效表单 -->
                <el-form
                  ref="subsidyFormRef"
                  :model="subsidyForm"
                  label-width="150px"
                  class="apply-form"
                >
                  <!-- 移除 disabled 属性，新增必填校验 -->
                  <el-form-item label="企业全称" prop="companyName">
                    <el-input
                      v-model="subsidyForm.companyName"
                      placeholder="请输入企业全称"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>

                  <!-- 移除 disabled 属性，新增必填校验 -->
                  <el-form-item label="统一社会信用代码" prop="creditCode">
                    <el-input
                      v-model="subsidyForm.creditCode"
                      placeholder="请输入统一社会信用代码"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>

                  <!-- 移除 disabled 属性，新增必填校验 -->
                  <el-form-item label="申报补贴类型" prop="subsidyType">
                    <el-select
                      v-model="subsidyForm.subsidyType"
                      placeholder="请选择补贴类型"
                      style="width: 100%"
                      :disabled="isDisabled"
                    >
                      <el-option
                        label="高新技术企业补贴"
                        value="高新技术企业补贴"
                      ></el-option>
                      <el-option
                        label="小微企业补贴"
                        value="小微企业补贴"
                      ></el-option>
                      <el-option label="研发补贴" value="研发补贴"></el-option>
                    </el-select>
                  </el-form-item>

                  <el-form-item label="申报金额(万元)" prop="applyAmount">
                    <el-input
                      v-model.number="subsidyForm.applyAmount"
                      placeholder="请输入申报金额"
                      type="number"
                      min="0"
                      step="0.01"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>

                  <el-form-item label="项目/业绩简述" prop="projectDesc">
                    <el-input
                      v-model="subsidyForm.projectDesc"
                      type="textarea"
                      :rows="4"
                      placeholder="请简述项目/业绩情况"
                      :disabled="isDisabled"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="驳回原因"
                    prop="auditRemark"
                    v-show="isDisabled && subsidyForm.auditStatus == 2"
                  >
                    <el-input
                      v-model="subsidyForm.auditRemark"
                      type="textarea"
                      :rows="3"
                      placeholder="请输入驳回原因（必填）"
                      maxlength="500"
                      show-word-limit
                      :disabled="isDisabled"
                    />
                  </el-form-item>
                </el-form>
              </div>

              <!-- 电子申请材料上传区域 -->
              <div class="form-section">
                <h2 class="section-title">电子申请材料上传</h2>
                <div class="upload-section">
                  <div class="upload-tip">
                    <span
                      class="required-tag"
                      style="display: inline-block; padding: 20px 0"
                      >必备材料清单</span
                    >
                  </div>

                  <!-- 文件上传组件 -->
                  <el-upload
                    ref="uploadRef"
                    class="uploader"
                    action="#"
                    :file-list="fileList"
                    :accept="acceptTypes"
                    :limit="10"
                    drag
                    :disabled="isDisabled"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      点击或拖拽上传文件（营业执照、审计报告、研发证明等）
                    </div>
                    <div class="el-upload__tip" slot="tip">
                      <span class="support-format"
                        >支持格式：PDF、DOC、JPG、PNG，单个文件不超过20MB，可多选。</span
                      >
                    </div>
                  </el-upload>
                </div>
              </div>
            </el-dialog>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSubsidy, getQualificationApplication } from '@/API/apply/apply.js';
export default {
  name: 'SubsidyQualification',
  data() {
    return {
      // 激活的 Tab
      activeTab: 'qualification', // 默认选中补贴资格Tab
      subsidyForm: {
        companyName: '',
        creditCode: '',
        subsidyType: '',
        applyAmount: '',
        projectDesc: '',
        attachmentUrl: '',
        auditRemark: '',
      },
      fileList: [],
      acceptTypes: '.pdf,.doc,.docx,.jpg,.jpeg,.png', // 支持的文件类型
      showDialog: false,
      reportRecords: [],
      isDisabled: false,
      // 补贴资格历史记录数据
      historyList: [],
    };
  },
  mounted() {
    this.getData();
    this.getQualiform();
  },
  methods: {
    getData() {
      getSubsidy().then((res) => {
        if (res.code === 200) {
          this.reportRecords = res.data.records;
        }
      });
    },
    getQualiform() {
      getQualificationApplication().then((res) => {
        if (res.code === 200) {
          this.historyList = res.data.records;
        }
      });
    },
    handleClick(scope) {
      this.showDialog = true;
      this.subsidyForm = scope.row;
      this.isDisabled = true;
      this.fileList = [];
      this.fileList = JSON.parse(this.subsidyForm.attachmentUrl);
    }
  },
};
</script>

<style scoped lang="less">
.subsidy-qualification-page {
  background: #f5f7fa;
  min-height: 100vh;
  padding: 20px;

  // Tab 导航样式
  .tab-nav {
    margin: 20px 220px;
    //max-width: 1000px;
    //margin: 0 auto 20px;
    display: flex;
    background: #fff;
    border-radius: 8px 8px 0 0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .tab-item {
      flex: 1;
      text-align: center;
      padding: 16px 0;
      font-size: 16px;
      color: #606266;
      cursor: pointer;
      transition: all 0.3s;
      border-bottom: 3px solid transparent;

      &:hover {
        color: #409eff;
      }

      &.active {
        color: #409eff;
        border-bottom: 3px solid #409eff;
        font-weight: 600;
      }
    }
  }

  .container {
    margin: 0px 220px;
    background: #fff;
    border-radius: 0 8px 8px 8px;
    padding: 24px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  }

  // Tab 占位内容样式
  .tab-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 600px;
    color: #909399;
    font-size: 18px;

    .placeholder-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 16px;

      i {
        font-size: 48px;
        color: #dcdfe6;
      }
    }
  }

  // 资格标签
  .qualification-tag {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #00b578;
    font-weight: 500;
    margin-bottom: 20px;

    i {
      color: #00b578;
      margin-right: 8px;
      font-size: 18px;
    }
  }

  // 分析标题
  .analysis-title {
    display: flex;
    align-items: center;
    font-size: 18px;
    color: #303133;
    font-weight: 600;
    margin-bottom: 20px;

    i {
      color: #409eff;
      margin-right: 8px;
    }
  }

  // 数据卡片
  .data-cards {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;
    flex-wrap: wrap;

    .data-card {
      flex: 1;
      min-width: 200px;
      background: #f0f9ff;
      border-radius: 8px;
      padding: 20px;
      text-align: center;

      .data-value {
        font-size: 32px;
        font-weight: 700;
        color: #303133;
        margin-bottom: 8px;
        line-height: 1.2;
      }

      .data-label {
        font-size: 14px;
        color: #606266;
      }
    }

    .benchmark-card {
      .data-value {
        font-size: 24px;
        color: #0088ff;
      }

      .data-label {
        font-size: 12px;
        color: #909399;
      }
    }
  }

  // 综合指数
  .index-section {
    background: #f0f9ff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;

    .index-title {
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 12px;
    }

    .progress-container {
      margin-bottom: 10px;

      .index-progress {
        --el-progress-text-color: #303133;

        .progress-text {
          font-size: 16px;
          font-weight: 600;
        }
      }
    }

    .index-desc {
      font-size: 14px;
      color: #606266;
      line-height: 1.6;
    }
  }

  // 审批决策
  .decision-section {
    background: #f0f9ff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 30px;

    .decision-title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      margin-bottom: 12px;

      i {
        color: #e6a23c;
        margin-right: 8px;
      }
    }

    .decision-content {
      display: flex;
      align-items: flex-start;
      font-size: 14px;
      color: #606266;
      line-height: 1.6;

      i {
        color: #4cd964;
        margin-right: 8px;
        margin-top: 2px;
      }
    }
  }

  // 历史记录
  .history-section {
    .history-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;

      .history-title {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
        color: #303133;

        i {
          color: #409eff;
          margin-right: 8px;
        }
      }

      .refresh-btn {
        color: #409eff;
        font-size: 14px;
      }
    }

    .history-table {
      width: 100%;

      .conclusion-tag {
        --el-tag-padding: 4px 8px;
        --el-tag-font-size: 12px;
      }
    }
  }
}

// 移动端适配
@media (max-width: 768px) {
  .subsidy-qualification-page {
    padding: 10px;

    .tab-nav .tab-item {
      padding: 12px 0;
      font-size: 14px;
    }

    .container {
      padding: 16px;
    }

    .data-cards {
      flex-direction: column;
      gap: 12px;
    }

    .tab-placeholder {
      min-height: 400px;

      .placeholder-content i {
        font-size: 32px;
      }

      .placeholder-content span {
        font-size: 16px;
      }
    }
  }
}
.subsidy-application-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background: #f8f9fa;
  min-height: 100vh;

  // 页面头部
  .page-header {
    margin-bottom: 30px;
    h1 {
      font-size: 24px;
      color: #333;
      margin: 0 0 10px 0;
      font-weight: 600;
    }
    .progress-bar {
      font-size: 14px;
      color: #666;
    }
  }

  // 表单主体
  .application-form {
    background: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);

    // 表单分区
    .form-section {
      margin-bottom: 40px;
      .section-title {
        font-size: 18px;
        color: #333;
        margin: 0 0 20px 0;
        font-weight: 600;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
      }
    }

    // 基础表单样式
    .info-form {
      .el-form-item {
        margin-bottom: 20px;
      }
      .el-input,
      .el-select,
      .el-textarea {
        width: 600px;
      }
    }

    // 文件上传区域
    .upload-section {
      .upload-tip {
        margin-bottom: 15px;
        .required-tag {
          color: #e6a23c;
          font-weight: 500;
        }
      }
      .uploader {
        width: 100%;
        .el-upload {
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          cursor: pointer;
          position: relative;
          overflow: hidden;
          transition: var(--el-transition-duration-fast);
          padding: 20px;
          text-align: center;
        }
        .el-upload:hover {
          border-color: var(--el-color-primary);
        }
        .support-format {
          color: #999;
          font-size: 12px;
        }
      }
    }

    // 提交按钮区域
    .submit-section {
      margin-top: 30px;
      text-align: center;
      .submit-btn {
        width: 300px;
        height: 48px;
        font-size: 16px;
        background: #1989fa;
        border: none;
        border-radius: 4px;
        &:hover {
          background: #0c6ede;
        }
      }
    }
  }
}

// 适配移动端
@media (max-width: 768px) {
  .subsidy-application-page {
    padding: 10px;
    .application-form {
      padding: 15px;
      .info-form {
        .el-input,
        .el-select,
        .el-textarea {
          width: 100%;
        }
      }
      .submit-section .submit-btn {
        width: 100%;
      }
    }
  }
}

// 移动端适配
@media (max-width: 768px) {
  .performance-upload-page {
    padding: 15px;

    .form-container {
      padding: 15px;

      .form-header {
        h2 {
          font-size: 16px;
        }
      }

      .performance-form {
        .el-form-item {
          label-width: 80px !important;
        }
      }
    }
  }
}
.price-report-wrapper {
  display: flex;
  justify-content: center;
  //min-height: calc(100vh - 60px);
  background-color: #f5f7fa;

  .price-report-card {
    width: 100%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    padding: 24px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    }
  }

  .operation-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f2f5;

    .title {
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      color: #303133;
      display: flex;
      align-items: center;

      i {
        margin-right: 10px;
        color: #409eff;
        font-size: 24px;
      }
    }

    .action-buttons {
      display: flex;
      gap: 12px;

      .action-btn {
        padding: 10px 16px;
        border-radius: 6px;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
        }
      }

      .primary-btn {
        background: linear-gradient(135deg, #409eff, #66b1ff);
        border: none;
      }
    }
  }

  .table-container {
    margin: 0 auto;
    overflow: hidden;
    border-radius: 6px;
    border: 1px solid #ebeef5;

    .elegant-table {
      ::v-deep .el-table__header-wrapper {
        th {
          font-weight: 600;
          letter-spacing: 0.5px;
        }
      }

      ::v-deep .el-table__body-wrapper {
        .el-table__row {
          transition: background-color 0.3s;

          &:hover {
            background-color: #f8fafc;
          }

          .cell {
            .company-name {
              font-weight: 500;
              color: #303133;
            }
          }
        }
      }

      .detail-btn {
        color: #409eff;
        padding: 8px 12px;
        border-radius: 4px;
        transition: all 0.3s;

        i {
          margin-right: 6px;
        }

        &:hover {
          background: rgba(64, 158, 255, 0.1);
          color: #66b1ff;
        }
      }

      ::v-deep .el-table__empty-block {
        min-height: 300px;
        display: flex;
        align-items: center;
        justify-content: center;

        .el-table__empty-text {
          color: #909399;
          font-size: 16px;
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .price-report-wrapper {
    padding: 16px;

    .price-report-card {
      padding: 16px;
    }

    .operation-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 16px;

      .action-buttons {
        width: 100%;
        flex-wrap: wrap;
      }
    }

    .table-container {
      overflow-x: auto;
    }
  }
}
</style>
